<template>
    <div class="btn-box">
        <el-card shadow="hover" v-if="serviceOffer.status">
            <div slot="header">
                <span style="color: #fff;font-weight: 600;font-size: 18px;">操作</span>
                <el-button style="float: right; padding: 3px 0;color: #fff;line-height: 18px" class="danger"
                           type="text" @click="zfoffer()">作废服务
                </el-button>
            </div>
            <div class="state-btn-box">
                <el-button type="primary" plain size="medium" @click="editOffer()">编辑服务</el-button>
                <el-button type="primary" plain size="medium" @click="openremark()">添加备注</el-button>
            </div>
        </el-card>
        <el-card shadow="hover" class="whiteback">
            <div slot="header">
                <span style="color: #409EFF;font-weight: 600;font-size: 18px;">服务日志</span>
            </div>
            <div class="log-box">
                <div class="log-item" v-for="(item,index) in remark" :key="index">
                    <div class="right-20">{{item.operateUserName}}</div>
                    <p>{{item.operateTime}}</p>
                    <p>备注：{{item.remark}}</p>
                </div>
                <div v-if="!remark.length" style="font-size: 14px;color: #999999;">暂无日志</div>
            </div>
        </el-card>
        <el-dialog
                title="添加备注"
                :visible.sync="remarkShow"
                :close-on-click-modal="false"
                width="600px"
                ref="dialog"
                append-to-body
        >
            <el-input
                    type="textarea"
                    :autosize="{ minRows: 4 }"
                    placeholder="请输入备注"
                    v-model="remarkTextarea"
                    maxlength="1000"
            >
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="submitRemark">提 交</el-button>
            </span>
        </el-dialog>
        <el-dialog
                title="作废操作"
                :visible="showZFModel"
                :close-on-click-modal="!showZFModel"
                :before-close="closeZFModel"
                width="500px"
        >
            <div class="pad-20">
                <h3>您正在执行作废操作，一旦确认，Offer【{{zfname}}】被作废，请谨慎操作</h3>
                <div class="dialog-footer" style="text-align: center;margin-top: 40px;" slot="footer">
                    <el-button type="primary" @click="confirmZF()">确认作废</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {getrzdata,addRemark,updateofferStatus} from "@/service/dataFrame";
    import {getStorageUserRoleId} from '@/utils/store'

    export default {
        name: "rightofferBox",
        props:{
            serviceOffer:{
                type:Object
            }
        },
        data() {
            return {
                remark: [],
                remarkShow: false,
                remarkTextarea: '',
                showZFModel:false,
                zfname:''
            }
        },
        methods: {
            zfoffer(){
                this.showZFModel=true;
                let name = this.serviceOffer.serviceName;
                this.zfname = name;
            },
            async confirmZF(){
                let param={
                    id:this.$route.query.id,
                    status:false,
                    userId:getStorageUserRoleId()
                }
                let res = await updateofferStatus(param)
                if (res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success("作废成功");
                this.showZFModel =false;
                this.zfname ='';
                this.$router.push({path: '/dataFrame/serviceLibrary'})
            },
            closeZFModel(){
                this.showZFModel =false;
                this.zfname ='';
            },
            openremark(){
                this.remarkShow=true;
                this.remarkTextarea='';
            },
            editOffer() {
                this.$router.push({path: '/dataFrame/newServices', query: {id: this.$route.query.id, isedit: 1}})
            },
            async getrzList() {
                let res = await getrzdata(this.$route.query.id)
                if (res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.remark = res.Data;
                console.log(res)
            },
            async submitRemark() {
                let param = {
                    id:this.$route.query.id,
                    remark:this.remarkTextarea,
                    userId:getStorageUserRoleId()
                }
                let res =await addRemark(param);
                if (res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success("添加成功");
                this.remarkShow =false;
                this.remarkTextarea ='';
                this.getrzList();
                this.$emit("refreshList")
            }
        },
        activated() {
            this.getrzList();
        }
    };
</script>
<style lang="scss">
    .state-btn-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: row;
        flex-wrap: wrap;

        .el-button {
            flex: 1;
            margin: 5px 10px;
        }
    }

    .danger {
        color: #f56c6c;
    }

    .danger:focus, .danger:hover {
        color: #f78989;
    }

    .whiteback {
        margin-top: 20px;

        .log-item {
            border-bottom: 1px solid #E5E5E5;
        }

        .right-20 {
            position: absolute;
            right: 30px;
        }

        .el-card__header {
            border-top: 2px solid #409EFF;
            background: #ffffff !important;
            padding: 10px 20px;
        }
    }

    .btn-box {
        .el-card__header {
            background: #409EFF;
            padding: 10px 20px;
        }

        .el-button--primary.is-plain {
            background: none;

            &:hover,
            &:focus {
                background: #409EFF;
            }
        }

        .el-button--danger.is-plain {
            background: none;

            &:hover,
            &:focus {
                background: #F56C6C;
            }
        }

        .el-drawer__body {
            padding: 20px;
        }

        .demo-drawer__content {
            display: flex;
            flex-direction: column;
            height: calc(100% - 40px);
        }

        .el-drawer.rtl {
            overflow-y: auto;
        }

        .el-drawer__header {
            margin-bottom: -20px !important;
        }

        .el-drawer__header {
            position: relative;
            z-index: 2;
        }

        .countdown-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            padding-bottom: 38px;

            .items-countdown {
                flex: 1;
                text-align: center;

                p {
                    font-size: 18px;
                    font-weight: bold;
                    color: #666666;
                }

                .items-time-box {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #333333;

                    i {
                        font-style: normal;
                        padding: 0 6px;
                    }

                    .items-time {
                        color: #fff;
                        width: 32px;
                        height: 32px;
                        background: #f75959;
                        text-align: center;
                        line-height: 32px;
                        font-size: 20px;
                    }
                }
            }
        }
    }
</style>
